import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BorderlessButton from "../components/Button/BorderlessButton";
import ContextMenu from "../components/ContextMenu/ContextMenu";
import ContextMenuButton from "../components/ContextMenu/ContextMenuButton";
import ContextMenuTrigger from "../components/ContextMenu/ContextMenuTrigger";
import { useTranslation } from "react-i18next";
import { useLang } from "../context/LangContext";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import UpDownIcon from "../components/Icons/UpDownIcon";
function LangSettingButton() {
  const { lang, setLang } = useLang();
  const { t } = useTranslation();

  const langMenu = [
    { name: t("auto_detect"), value: "system" },
    { name: "简体中文", value: "zh-CN" },
    { name: "中文（香港）", value: "zh-HK" },
    { name: "中文（台灣）", value: "zh-TW" },
    { name: "English", value: "en" },
    // { name: "日本語", value: "ja" },
  ];

  const langName = (() => {
    return langMenu.find((item) => item.value === lang)?.name;
  })();

  return (
    <div className="flex flex-row items-center">
      <ContextMenuTrigger
        trigger={<BorderlessButton text={`${t("lang")}: ${langName}`} rightIcon={<UpDownIcon />} />}
        contextMenu={
          <ContextMenu>
            {langMenu.map((item) => {
              return (
                <ContextMenuButton
                  key={item.value}
                  leftIcon={<FontAwesomeIcon icon={faCheck} />}
                  text={item.name}
                  showIcon={lang === item.value}
                  onClick={() => {
                    setLang(item.value);
                  }}
                ></ContextMenuButton>
              );
            })}
          </ContextMenu>
        }
      ></ContextMenuTrigger>
    </div>
  );
}

export default LangSettingButton;
